import type { ReactElement, ReactNode } from 'react';

import { Flex, type FlexProps } from '@bonusly/design-system';

type LockedChipStyle = 'align' | 'justify' | 'borderRadius' | 'outline' | 'outlineColor' | 'boxShadow' | 'flexShrink';

export interface BizyLogoChipProps extends Omit<FlexProps, LockedChipStyle | 'children'> {
	children: ReactNode;
}

/**
 * Shared circular shell for Bizy source and connector marks.
 * The outside outline and shadow match the connector-chip design treatment.
 */
export function BizyLogoChip({ children, ...props }: BizyLogoChipProps): ReactElement {
	return (
		<Flex
			{...props}
			align="center"
			justify="center"
			borderRadius="full"
			outline="1px solid"
			outlineColor="text.onColor"
			boxShadow="sm"
			flexShrink={0}
			data-component="bizy-logo-chip"
		>
			{children}
		</Flex>
	);
}
